<template>
    <dashboard-layout>
        <v-container fluid class="down-top-padding py-0">
            <BaseBreadcrumb
            :title="page.title"
            :icon="page.icon"
            :breadcrumbs="breadcrumbs"
            ></BaseBreadcrumb>
            <v-row dense>
                <v-col cols="12">
                    <table-biz-partners></table-biz-partners>
                </v-col>
            </v-row>
        </v-container>
    </dashboard-layout>
</template>

<script>
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import TableBizPartners from './TableGrids/TableBizPartners.vue'

export default {
    name: 'BizPartners',
    props: {

    },
    components: {
        DashboardLayout,
        BaseBreadcrumb,
        TableBizPartners,
    },
    data() {
        return {
            page: {
                title: "Business Partners",
            },
            breadcrumbs: [
                { text: "Business Partners", disabled: true },
            ],
        }
    },
    watch: {},
    computed: {},
    mounted: function () {},
    methods: {

    }
}
</script>
